import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { AccordionPanelComponent } from '@epicuro-next/ataraxia/accordion';
import { fade } from '@epicuro-next/ui';
import { Site, SubSite } from 'graphql-api/gql-api-interfaces';
import { BehaviorSubject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { siteDesktopPositions, siteMobilePositions } from '../../utils';

@Component({
  selector: 'epc-brand-org-sub-sites',
  templateUrl: './brand-org-sub-sites.component.html',
  styleUrls: ['./brand-org-sub-sites.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [fade],
  standalone: false,
})
export class BrandOrgSubSitesComponent implements OnChanges {
  @Input()
  public site: Site;

  @Output()
  public selectedSubSite: EventEmitter<Site | SubSite> = new EventEmitter<
    Site | SubSite
  >();

  @Input()
  public isMobile = false;

  @Input()
  public selectorIsOpened = false;

  @Input()
  public height = 0;

  @Output()
  public siteClicked = new EventEmitter();

  @ViewChild('accordionPanelRef')
  public accordionRef: AccordionPanelComponent;

  @HostBinding('class.site-option')
  public get hostClass() {
    return !this.accordionRef?.open;
  }

  private opened$ = new BehaviorSubject(false);

  public selectorOpened$ = this.opened$.pipe(debounceTime(50));

  public desktopPositions = siteDesktopPositions;
  public mobilePositions = siteMobilePositions;

  public setOpenState(value: boolean): void {
    if (this.selectorIsOpened) {
      this.opened$.next(value);
    }
  }

  public onSelectSiteClick(site: Site) {
    this.setOpenState(false);
    this.selectedSubSite.emit(site);
  }

  public ngOnChanges(changes: SimpleChanges) {
    const { selectorIsOpened } = changes;

    if (this.isMobile) {
      if (selectorIsOpened?.currentValue === false && this.accordionRef?.open) {
        this.accordionRef?.toggleMenu();
      }
    } else {
      if (selectorIsOpened?.currentValue === false) {
        this.opened$.next(false);
      }
    }
  }
}
